import React, { Component } from 'react';
import './Header.css';
import majales from './majales.svg';
import { Parallax } from 'react-scroll-parallax';

class Header extends Component {
  render() {
    return (
      <div className="header1">
        <Parallax
        className="custom-class"
        offsetYMax={200 + '%'}
        offsetYMin={-200 + '%'}
        slowerScrollRate
        tag="figure"
    >
        <img src={majales} alt="majales" className="majales" />
    </Parallax>
      		<p className="datum h1-responsive">7. května</p>
      </div>
    );
  }
}

export default Header;
